/********************************************
* Testimonial carousel
********************************************/
function fnTestimonialCarousel( i, oSection ) {

	/*****************
	* Objects
	*****************/
	var oSection					= $( oSection ),
		oCarousel					= $( '.slick-slider', oSection );

	/*****************
	* Carousel configuration
	*****************/
	oCarousel.slick({
		touchThreshold:   	 		20,
		autoplay:   	      		false,
		dots:   	          		true,
		arrows:   	        		false,
		infinite:   	        	true,
		fade:						true,
		slidesToShow: 				1,
		speed:   	         		500,
		variableWidth:				false,
		adaptiveHeight:   			true,
		mobileFirst:   	   			true,
		focusOnSelect:   	 		false,
		appendDots:			    	'section.testimonial-carousel nav.dots'
	});

}


// END OF DOCUMENT
